import { FC, useMemo } from 'react'
import Quote from 'src/components/Quote'
import { ImageTransformer } from 'src/relay/Transformers/ImageTransformer'

import { BlockProps } from '../props'

import { QuoteProps } from './props'

const QuoteBlock: FC<BlockProps<QuoteProps>> = ({ data }) => {
  const props = useMemo(() => {
    // v4: `quote.data.attributes.*`; v5: flat on `quote`.
    const quoteRaw: any = (data.quote as any)?.data ?? data.quote
    const attrs: any = quoteRaw?.attributes ?? quoteRaw
    const desktopImage = attrs?.desktopImage?.data ?? attrs?.desktopImage
    const mobileImage = attrs?.mobileImage?.data ?? attrs?.mobileImage
    const imageProps = ImageTransformer(desktopImage, {
      desktop: '100vw, 75vw',
    })
    const mobileImageProps = ImageTransformer(mobileImage, {
      desktop: '100vw, 75vw',
    })
    return {
      ...(attrs?.content && {
        richTextProps: { html: attrs.content },
      }),
      ...(attrs?.personName && { author: attrs.personName }),
      ...(attrs?.personProfession && { status: attrs.personProfession }),
      ...(imageProps && {
        pictureProps: {
          imageProps,
          ...(mobileImageProps && { mobileImageProps }),
        },
      }),
    }
  }, [data])

  return <Quote {...props} />
}
export default QuoteBlock
